
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class UserService {
    constructor(private http: HttpClient) {}

    saveUserGoal(participantId, value) {
        return this.http.post('/api/v1/user/participant/' + participantId + '/goal', value).pipe(map(res => {
            return res;
        }));
    }

    saveUserImage(imageId) {
        return this.http.post('/api/v1/user/image', {
            imageID: imageId
        }).pipe(map(res => {
            return res;
        }));
    }

    saveUsername(currentPassword, username) {
        return this.http.post('/api/v1/auth/username', {
            password: currentPassword,
            username: username
        });
    }

    savePassword(currentPassword, newPassword) {
        return this.http.post('/api/v1/auth/password', {
            password: currentPassword,
            newPassword: newPassword
        });
    }

    convertGraphqlToModel(gqlRes) {
        let participant = gqlRes.Participant[0],
            constituent = gqlRes.Participant[0].individualConstituent;

        var model = {
            constituent: {
                constituentID: constituent.individualConstituentId,
                firstName: constituent.firstName,
                lastName: constituent.lastName,
                middleInitial: constituent.middleInitial,
                suffix: constituent.suffix,
                individualConstituentDetails: {
                    allergies: constituent.allergies,
                    insuranceCompany: constituent.insuranceCompany,
                    currentMedications: constituent.currentMedications,
                    currentMedicalConditions: constituent.currentMedicalConditions,
                    dateOfBirth: constituent.dateOfBirth,
					llsImageId: constituent.imageId,
					imagePath: constituent.imagePath
                },
                addresses: [],
                emails: [],
                phones: [],
                preferredAddress: null,
                prefixType: {
                    prefixTypeId: (constituent.prefixType ? constituent.prefixType.cmgmtPrefixTypeId : null),
                    name: (constituent.prefixType ? constituent.prefixType.name : null)
                }
            },
            emergencyContacts: []
        };

        constituent.constituentEmails.forEach(email => {
            model.constituent.emails.push({
                constituentEmailID: email.constituentEmailId,
                email: email.email,
                emailType: {
                    emailTypeID: email.emailType.cmgmtEmailTypeId,
                    name: email.emailType.name
                },
                primary: email.primaryFl
            });
        });
        constituent.constituentPhones.forEach(phone => {
            model.constituent.phones.push({
                phoneID: phone.constituentPhoneId,
                areaCode: phone.areaCode,
                countryCode: phone.countryCode,
                phoneNumber: this.getPhoneNumberWithAreaCode(phone.areaCode, phone.phoneNumber),
                phoneType: {
                    constituentPhoneTypeID: phone.phoneType.cmgmtPhoneTypeId,
                    name: phone.phoneType.name
                },
                primary: phone.primaryFl
            });
        });
        constituent.constituentAddresses.forEach(address => {
            model.constituent.addresses.push({
                constituentAddressID: address.constituentAddressId,
                address1: address.address1,
                address2: address.address2,
                address3: address.address3,
                addressType: {
                    constituentAddressTypeID: address.addressType.addressTypeId,
                    name: address.addressType.name
                },
                city: address.city,
                country: address.country,
                county: address.county,
                postalCode: address.postalCode,
                state: address.state,
                primary: address.primaryFl
            });
        });
        participant.emergencyContacts.forEach(contact => {
            contact.emergencyContactPhones.forEach(phone => {
                model.emergencyContacts.push({
                    constituentRelationshipTypeId: phone.emergencyContact.constituentRelationshipType.constituentRelationshipTypeId,
                    emergencyContactTypeId: phone.emergencyContact.emergencyContactType.emergencyContactTypeId,
                    emergencyContactPhones: [{
                        emergencyContactPhoneId : phone.cmgmtEmergencyContactPhoneId,
                        phoneNumber: this.getPhoneNumberWithAreaCode(phone.areaCode, phone.phoneNumber),
                        phoneType: {
                            constituentPhoneTypeID: phone.phoneType.cmgmtPhoneTypeId
                        },
                        primary: true
                    }],
                    firstName: contact.contactFirstName,
                    lastName: contact.contactLastName
                });
            });
        });

        return model;
    }

    getPhoneNumberWithAreaCode(areaCode, phoneNumber) {
        if (areaCode) {
            return '(' + areaCode + ')' + phoneNumber;
        } else {
            return phoneNumber;
        }
    }
}
